import { gql } from 'apollo-angular';

const CANCEL_RFP = gql`
  mutation cancelRfp($id: Long!) {
    cancelRfp(cancelRfpRequest: { id: $id }) {
      id
      status
    }
  }
`;

export default CANCEL_RFP;
